import { useUiSettings, useSaveUiSettings } from "../api/uiSettings";

export function SettingsView() {
  const { data, isLoading } = useUiSettings();
  const save = useSaveUiSettings();

  return (
    <div className="settings-layout">
      <h2>Settings</h2>

      <section className="settings-section">
        <h3>Transcription appearance</h3>
        <label className="settings-toggle">
          <input
            type="checkbox"
            disabled={isLoading || save.isPending}
            checked={data?.calm_transcripts ?? false}
            onChange={(e) => save.mutate({ calm_transcripts: e.target.checked })}
          />
          <span>
            <strong>Calm document theme for transcription pages</strong>
            <em>
              Light, document-styled presentation matching the rendered PDFs. Applies to
              family users everywhere, and to you on the Transcripts and Upload tabs.
              Off restores the standard dark theme for everyone.
            </em>
          </span>
        </label>
        {save.isError && <div className="tr-error">Save failed — try again.</div>}
      </section>
    </div>
  );
}
